module.exports = __webpack_public_path__ + "img/bts.de56eb3e.svg";